import { Stack } from "@mantine/core"
import { useForm } from "@mantine/form"
import { Button } from "@tfg/ui"
import { useEffect, useState } from "react"

import { RenderField } from "./RenderField"

interface selectField {
  label: string
  value: string
}

export type formFieldType =
  | "text"
  | "select"
  | "multiselect"
  | "countrySelect"
  | "languageSelect"
  | "tagsInput"

export interface FormFieldConfig {
  type: formFieldType
  name: string
  label: string
  placeholder: string
  customClass?: CSSModuleClasses
  options?: selectField[]
}

export interface FormConfig<T> {
  validate: any
  initialValues: T
}

export interface TypesFormProps<T> {
  fields: FormFieldConfig[]
  submitLabel: string
  formConfig: FormConfig<T>
  mutate: (values: T) => void
  closeDrawer?: () => void
}

export const TypesForm = <T extends Record<string, any>>(
  props: TypesFormProps<T>
) => {
  const [formConfig, setFormConfig] = useState<FormConfig<T>>({
    ...props.formConfig,
  })

  useEffect(() => {
    setFormConfig(props.formConfig)
  }, [props.formConfig])
  const form = useForm({
    ...formConfig,
    validateInputOnChange: true,
  })

  const handleSubmit = () => {
    props.mutate(form.values)
    form.reset()
    if (props.closeDrawer) {
      props.closeDrawer()
    }
  }
  return (
    <>
      <form onSubmit={form.onSubmit(() => handleSubmit())}>
        <Stack>
          {props.fields.map((field) => RenderField({ fields: field, form }))}
          <Button disabled={!form.isValid()} type="submit">
            {props.submitLabel}
          </Button>
        </Stack>
      </form>
    </>
  )
}
